__turbopack_context__.v({
  "item": "RLapjq_item",
  "text": "RLapjq_text",
  "withDivider": "RLapjq_withDivider",
});
